import BaseService from "@/app/core/base/BaseService";
import AddressField from "@/app/core/layouts/main-components/delivery/AddressField";
import { Autocomplete } from "@/app/core/util/helpers/AutocompleteHelper";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import { Countries, CurrencyOption } from "@/app/core/util/helpers/MoneyHelper";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import React, { useState } from "react";
import { useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";
import Axios from "axios";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";

export default function InternationalAddressStep({ infos,
    reportAddresses,
    reportOriginResponsible,
    reportDestinationResponsible,
    addressBook }) {
    const [origin, setOrigin] = useState({ residential: false })
    const [destination, setDestination] = useState({ residential: false })
    const [resultsDestination, setResultsDestination] = useState([])
    const [resultsOrigin, setResultsOrigin] = useState([])
    const [setQuery] = useState("");
    const date = new Date();
    const [change, setChange] = useState(date.getTime());

    useEffect(() => {
        loadInfos()
    }, [infos])

    function notifyChange() {
        setChange(date.getTime());
    }

    function loadInfos() {
        if (infos.origin != undefined && infos.destination != undefined) {
            console.log("Endereços antigos", infos)
            setOrigin(infos.origin)
            setDestination(infos.destination)
        }
    }

    function handleOriginChange(evt, type) {
        setOrigin(OnDataChange(origin, evt, type));
        if (evt.target.name == "country") {
            setResultsOrigin(autocomplete(evt.target.value))
        }
    }

    function handleDestinationChange(evt, type) {
        setDestination(OnDataChange(destination, evt, type));
        if (evt.target.name == "country") {
            setResultsDestination(autocomplete(evt.target.value))
        }
    }

    function autocomplete(value) {
        let countries_to_show = [];

        if (value.length > 0) {
            countries_to_show = Autocomplete(value, Countries, "Term");
            return countries_to_show;
        } else {
            countries_to_show = [];
            return [];
        }
    }

    function endAddresses(e) {
        if (e != undefined) {
            e.preventDefault();
        }
        let message = "";
        let messageDestination = "";
        let error = false;
        if (!origin.zipCode) {
            message += `${Translate(Message.PostalCode)}; `;
        }
        if (!origin.country) {
            message += `${Translate(Message.Country)}; `;
        }
        if (!origin.city) {
            message += `${Translate(Message.City)}; `;
        }
        if (!origin.name) {
            message += `${Translate(Message.SendersName)}; `;
        }
        if (origin.addressLine1 == "" || !origin.addressLine1) {
            message += `${Translate(Message.ErrorAddressLine1)}; `;
        }
        if (message.length > 0) {
            toast.error(`${message}`);
            error = true;
        }

        if (!destination.zipCode) {
            messageDestination += `${Translate(Message.PostalCode)}; `;
        }
        if (!destination.country) {
            messageDestination += `${Translate(Message.Country)}; `;
        }
        if (!destination.city) {
            messageDestination += `${Translate(Message.City)}; `;
        }
        if (!destination.name) {
            messageDestination += `${Translate(Message.RecipientName)}; `;
        }
        if (destination.addressLine1 == "" || !destination.addressLine1) {
            messageDestination += `${Translate(Message.ErrorAddressLine1)}; `;
        }
        if (messageDestination.length > 0) {
            toast.error(`${messageDestination}`);
            error = true;
        }
        if (origin.country == destination.country && origin.country == "BR") {
            if (!origin.neighborhood || !destination.neighborhood) {
                toast.error(Translate(Message.MandatoryNeighborhood));
                error = true;
            }
        }

        console.log("Endereços formatados", origin, destination);

        if (error) {
            return;
        } else {
            let baseOrigin = origin;
            let baseDestination = destination;

            // if (!baseDestination.countryCode) {
            //     baseDestination.countryCode = baseDestination.country;
            // }

            // if (!baseOrigin.countryCode) {
            //     baseOrigin.countryCode = baseOrigin.country;
            // }

            reportAddresses({ origin: baseOrigin, destination: baseDestination });
        }
    }

    function selectOrigin(item) {
        let base = { ...origin, ...item };
        base.country = item.country;
        base.country_code = item.country;
        base.state = item.state;
        base.state_code = item.state;
        base.address = `${item.number}, ${item.street}, ${item.neighborhood} | ${item.city} - ${item.state}`
        setOrigin(base);
        reportOriginResponsible(base);
    }

    function selectDestination(item) {
        let base = { ...destination, ...item };
        base.country = item.country;
        base.country_code = item.country;
        base.state = item.state;
        base.state_code = item.state;
        base.address = `${item.number}, ${item.street}, ${item.neighborhood} | ${item.city} - ${item.state}`
        setDestination(base);
        reportDestinationResponsible(base);
    }

    function changePlace() {
        const oldOrigin = origin;
        const oldDestination = destination;

        setOrigin(oldDestination);
        setDestination(oldOrigin);
    }

    async function preProcessOriginAddress() {
        if (origin.country && origin.country.length > 0 && origin.zipCode && origin.zipCode.length > 0) {
            if (!origin.state || !origin.addressLine1) {

                Axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${origin.country}%20${origin.zipCode}&key=AIzaSyCaCcyoHcSIwb5DSBtku4XdwrXQZ-elwBQ`, {})
                    .then(function (response) {

                        console.log("Resultados", { ...response.data });
                        const place = response.data.results;
                        let originResponse = origin;

                        let base = processResponse(place);

                        if (base.state) {
                            originResponse.state = base.state;
                        }
                        if (base.city) {
                            originResponse.city = base.city;
                        }
                        const baseAddres = `${base.street ? `${base.street}` : ""} ${base.neighborhood ? `${base.neighborhood}` : ""}`;

                        originResponse.addressLine1 = "";
                        if (baseAddres.length > 30) {
                            originResponse.addressLine1 = base.street;
                            originResponse.addressLine2 = base.neighborhood;
                        } else if (baseAddres == " ") {
                            originResponse.addressLine1 = base.formatted_address;
                        } else {
                            originResponse.addressLine1 = baseAddres;
                        }
                        console.log("Endereço", originResponse);
                        originResponse.country = origin.country;
                        setOrigin(originResponse);
                        notifyChange();
                    })
                    .catch(function (error) {
                        if (error) {
                            console.log("Resultados", error);
                        }
                    });
            }
        }
    }

    async function preProcessDestinationAddress() {
        if (destination.country && destination.country.length > 0 && destination.zipCode && destination.zipCode.length > 0) {
            if (!destination.state || !destination.addressLine1) {

                Axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${destination.country}%20${destination.zipCode}&key=AIzaSyCaCcyoHcSIwb5DSBtku4XdwrXQZ-elwBQ`, {})
                    .then(function (response) {

                        console.log("Resultados", { ...response.data });
                        const place = response.data.results;
                        let destinationResponse = destination;

                        let base = processResponse(place);

                        if (base.state) {
                            destinationResponse.state = base.state;
                        }
                        if (base.city) {
                            destinationResponse.city = base.city;
                        }
                        const baseAddres = `${base.street ? `${base.street}` : ""} ${base.neighborhood ? `${base.neighborhood}` : ""}`;

                        destinationResponse.addressLine1 = "";
                        if (baseAddres.length > 30) {
                            destinationResponse.addressLine1 = base.street;
                            destinationResponse.addressLine2 = base.neighborhood;
                        } else if (baseAddres == " ") {
                            destinationResponse.addressLine1 = base.formatted_address;
                        } else {
                            destinationResponse.addressLine1 = baseAddres;
                        }
                        console.log("Endereço", destinationResponse);
                        destinationResponse.country = destination.country;
                        setDestination(destinationResponse);
                        notifyChange();
                    })
                    .catch(function (error) {
                        if (error) {
                            console.log("Resultados", error);
                        }
                    });
            }
        }
    }

    function processResponse(place) {
        let base = {};
        for (let y in place) {
            const one = place[y].address_components;

            for (let s in one) {
                const item = one[s];

                const street = item.types.filter(x => x == "route");
                const neighborhood = item.types.filter(x => x == "sublocality_level_1" || x == "sublocality");
                const city = item.types.filter(x => (one.length < 7 && x == "postal_town" || x == "administrative_area_level_2") || (one.length >= 7 && x == "postal_town") || x == "locality");
                const state = item.types.filter(x => (one.length <= 7 && x == "administrative_area_level_1") || (one.length == 7 && x == "administrative_area_level_2") || (one.length > 7 && x == "administrative_area_level_1"));

                if (street.length > 0 && item.short_name != undefined) {
                    base.street = item.short_name;
                }
                if (neighborhood.length > 0 && item.short_name != undefined) {
                    base.neighborhood = item.short_name;
                }
                if (city.length > 0 && item.short_name != undefined) {
                    base.city = item.short_name;
                }
                if (state.length > 0 && item.short_name != undefined) {
                    base.state = item.short_name;
                }
            }

            base.formatted_address = place[y].formatted_address;
        }

        return base;
    }

    return (
        <div>
            <form onSubmit={e => endAddresses(e)} autoComplete="off">
                <div className="row">
                    <div className="col-4">

                    </div>
                    <div className="col-4 text-center" style={{ marginTop: 0 }}>
                        <button className="btn btn-warning" type="button" onClick={() => changePlace()}>
                            <i className="fa fa-arrow-left mr-1" />
                            <i className="fa fa-arrow-right" />
                        </button>
                    </div>
                    <div className="col-4 text-right" style={{ marginTop: -60 }}>
                        <CurrencyOption report={() => null} />
                    </div>
                    {/* Origem */}
                    <div className="block block-rounded block-bordered block-fx-pop mb-0 border-success col-md-6" key={`card-origin`}>
                        <div className="block-header">
                            <div className="block-title">
                                <i className="fa fa-map-marker-alt text-info mr-2"></i>{Translate(Message.OriginAddress)}
                            </div>
                            <div className="block-tools d-md-flex justify-content-md-between align-items-md-center">
                                <button className="btn btn-dual" type="button" onClick={() => setOrigin({ zipCode: "", number: "", addressLine1: "", addressLine2: "", addressLine3: "", complement: "", address: "", city: "", state: "", country: "", country: "", name: "" })}>{Translate(Message.ClearFields)}</button>
                                {addressBook && addressBook.length > 0 ?
                                    <Dropdown style={{ zIndex: 21 }} drop="left">
                                        <Dropdown.Toggle variant="light">
                                            <i className="fa fa-search" /> Procurar
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu style={{ width: 450 }}>
                                            <Typeahead
                                                options={addressBook}
                                                labelKey={(option) => `${option.name} - ${option.state} - ${option.country}`}
                                                onSearch={(q) => setQuery(q)}
                                                name="country"
                                                placeholder="Selecionar"
                                                id={`coleta-responsavel`}
                                                onChange={(selected) => {
                                                    if (selected[0] !== undefined || selected !== null) {
                                                        selectOrigin(selected[0])
                                                    }
                                                }} />
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    : ""}
                            </div>
                        </div>
                        <div className="ml-2 mr-2 mb-2 row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <span>*{Translate(Message.Country)}</span>
                                    <input
                                        name="country"
                                        placeholder="Selecionar"
                                        maxLength={2}
                                        className="form-control"
                                        key={`country-origin`}
                                        defaultInputValue={change && origin && origin.country}
                                        value={change && origin && origin.country}
                                        onChange={(evt) => handleOriginChange(evt)} />

                                    <ul
                                        style={resultsOrigin && resultsOrigin.length > 0 ? {
                                            borderRadius: "3px",
                                            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                            background: "rgba(255, 255, 255, 0.9)",
                                            padding: "2px 0",
                                            fontSize: "90%",
                                            position: "fixed",
                                            overflow: "auto",
                                            marginTop: 10,
                                            width: "30%",
                                            zIndex: 999999,
                                            maxHeight: "300px", // TODO: don't cheat, let it flow to the bottom
                                        } : {
                                            borderRadius: "3px",
                                        }}>
                                        {resultsOrigin && resultsOrigin.map((item) => {
                                            return (
                                                <li
                                                    className="m-3"
                                                    onClick={() => setOrigin({ ...origin, country: item.Code }) | setResultsOrigin([])}
                                                >
                                                    {`(${item.Code}) ${item.Name}`}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                            <div className="form-group col-md-6">
                                <span>*{Translate(Message.PostalCode)}</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    key={`zipCode-origin`}
                                    name="zipCode"
                                    value={change && origin && origin.zipCode}
                                    onChange={(evt) => handleOriginChange(evt)}
                                />
                            </div>

                            <div className="form-group col-md-6">
                                <span>{Translate(Message.State)}</span>
                                <input type="text" className="form-control" maxLength={2} name="state" onFocus={() => preProcessOriginAddress()} value={change && origin && origin.state} onChange={evt => handleOriginChange(evt)} />
                            </div>

                            <div className="form-group col-md-12">
                                <span>*{Translate(Message.AddressLine)} 1</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    key={`addressLine1-origin`}
                                    name="addressLine1"
                                    maxLength={30}
                                    value={change && origin && origin.addressLine1}
                                    onChange={(evt) => handleOriginChange(evt)}
                                />
                            </div>
                            <div className="form-group col-md-12">
                                <span>{Translate(Message.AddressLine)} 2 ({Translate(Message.Optional)})</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    key={`addressLine2-origin`}
                                    name="addressLine2"
                                    value={change && origin && origin.addressLine2}
                                    onChange={(evt) => handleOriginChange(evt)}
                                />
                            </div>
                            <div className="form-group col-md-12">
                                <span>{Translate(Message.AddressLine)} 3 ({Translate(Message.Optional)})</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    key={`addressLine3-origin`}
                                    name="addressLine3"
                                    value={change && origin && origin.addressLine3}
                                    onChange={(evt) => handleOriginChange(evt)}
                                />
                            </div>

                            <div className="form-group col-md-6">
                                <span>*{Translate(Message.City)}</span>
                                <input type="text" className="form-control" name="city" value={change && origin && origin.city} onChange={evt => handleOriginChange(evt)} />
                            </div>
                            <div className={"form-group col-md-6"}>
                                <span>*{Translate(Message.SendersName)}</span>
                                <input type="text" className="form-control" name="name" autocomplete="off" placeholder="Ex: Empresa LTDA ou Jhon Doe" value={change && origin && origin.name} onChange={evt => handleOriginChange(evt)} />
                            </div>
                            <div className="col-md-12">
                                <div class="custom-control custom-checkbox custom-control-lg mb-1">
                                    <input type="checkbox" class="custom-control-input" id="residentialOrigin" key="residentialOrigin" name="residential" value={origin.residential} onChange={(evt) => handleOriginChange({ target: { name: evt.target.name, value: evt.target.checked } })} />
                                    <label class="custom-control-label" for="residentialOrigin">Este é um endereço residencial</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Destino */}
                    <div className="block block-rounded block-bordered block-fx-pop mb-0 border-success col-md-6" key={`card-destination`}>
                        <div className="block-header">
                            <div className="block-title">
                                <i className="fa fa-flag-checkered text-success mr-2"></i>{Translate(Message.DestinationAddress)}
                            </div>
                            <div className="block-tools d-md-flex justify-content-md-between align-items-md-center">
                                <button className="btn btn-dual" type="button" onClick={() => setDestination({ zipCode: "", number: "", addressLine1: "", addressLine2: "", addressLine3: "", complement: "", address: "", city: "", state: "", country: "", country: "", name: "" })}>{Translate(Message.ClearFields)}</button>
                                {addressBook && addressBook.length > 0 ?
                                    <Dropdown drop="left">
                                        <Dropdown.Toggle variant="light">
                                            <i className="fa fa-search" /> Procurar
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu style={{ width: 450 }}>
                                            <Typeahead
                                                options={addressBook}
                                                labelKey={(option) => `${option.name} - ${option.state} - ${option.country}`}
                                                onSearch={(q) => setQuery(q)}
                                                name="country"
                                                placeholder="Selecionar"
                                                id={`coleta-responsavel`}
                                                onChange={(selected) => {
                                                    if (selected[0] !== undefined || selected !== null) {
                                                        selectDestination(selected[0])
                                                    }
                                                }} />
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    : ""}
                            </div>
                        </div>
                        <div className="ml-2 mr-2 mb-2 row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <span>*{Translate(Message.Country)}</span>
                                    <input
                                        name="country"
                                        placeholder="Selecionar"
                                        className="form-control"
                                        maxLength={2}
                                        key={`country-destination`}
                                        defaultInputValue={change && destination && destination.country}
                                        value={change && destination && destination.country}
                                        onChange={(evt) => handleDestinationChange(evt)} />
                                    <ul
                                        style={resultsDestination && resultsDestination.length > 0 ? {
                                            borderRadius: "3px",
                                            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                            background: "rgba(255, 255, 255, 0.9)",
                                            padding: "2px 0",
                                            fontSize: "90%",
                                            position: "fixed",
                                            overflow: "auto",
                                            marginTop: 10,
                                            width: "30%",
                                            zIndex: 999999,
                                            maxHeight: "300px", // TODO: don't cheat, let it flow to the bottom
                                        } : {
                                            borderRadius: "3px",
                                        }}>
                                        {resultsDestination && resultsDestination.map((item) => {
                                            return (
                                                <li
                                                    className="m-3"
                                                    onClick={() => setDestination({ ...destination, country: item.Code }) | setResultsDestination([])}
                                                >
                                                    {`(${item.Code}) ${item.Name}`}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                            <div className="form-group col-md-6">
                                <span>*{Translate(Message.PostalCode)}</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    key={`zipCode-destination`}
                                    name="zipCode"
                                    value={change && destination && destination.zipCode}
                                    onChange={(evt) => handleDestinationChange(evt)}
                                />
                            </div>

                            <div className="form-group col-md-6">
                                <span>{Translate(Message.State)}</span>
                                <input type="text" className="form-control" name="state" maxLength={2} onFocus={() => preProcessDestinationAddress()} value={change && destination && destination.state} onChange={evt => handleDestinationChange(evt)} />
                            </div>

                            <div className="form-group col-md-12">
                                <span>*{Translate(Message.AddressLine)} 1</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    key={`addressLine1-destination`}
                                    name="addressLine1"
                                    maxLength={30}
                                    value={change && destination && destination.addressLine1}
                                    onChange={(evt) => handleDestinationChange(evt)}
                                />
                            </div>
                            <div className="form-group col-md-12">
                                <span>{Translate(Message.AddressLine)} 2 ({Translate(Message.Optional)})</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    key={`addressLine2-destination`}
                                    name="addressLine2"
                                    value={change && destination && destination.addressLine2}
                                    onChange={(evt) => handleDestinationChange(evt)}
                                />
                            </div>
                            <div className="form-group col-md-12">
                                <span>{Translate(Message.AddressLine)} 3 ({Translate(Message.Optional)})</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    key={`addressLine3-destination`}
                                    name="addressLine3"
                                    value={change && destination && destination.addressLine3}
                                    onChange={(evt) => handleDestinationChange(evt)}
                                />
                            </div>

                            <div className="form-group col-md-6">
                                <span>*{Translate(Message.City)}</span>
                                <input type="text" className="form-control" name="city" value={change && destination && destination.city} onChange={evt => handleDestinationChange(evt)} />
                            </div>
                            <div className={"form-group col-md-6"}>
                                <span>*{Translate(Message.SendersName)}</span>
                                <input type="text" className="form-control" name="name" autocomplete="off" placeholder="Ex: Empresa LTDA ou Jhon Doe" value={change && destination && destination.name} onChange={evt => handleDestinationChange(evt)} />
                            </div>
                            <div className="col-md-12">
                                <div class="custom-control custom-checkbox custom-control-lg mb-1">
                                    <input type="checkbox" class="custom-control-input" id="residentialDestination" key="residentialDestination" name="residential" value={destination.residential} onChange={(evt) => handleDestinationChange({ target: { name: evt.target.name, value: evt.target.checked } })} />
                                    <label class="custom-control-label" for="residentialDestination">Este é um endereço residencial</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 text-center mt-2">
                        <button type="button" className="btn btn-hero-lg btn-hero-success mt-5" onClick={() => endAddresses()}>
                            {Translate(Message.Advance)} <i className="fa fa-arrow-right ml-2"></i>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}